<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = withDefaults(defineProps<{
  class?: HTMLAttributes["class"]
  variant?: "default" | "muted"
}>(), {
  variant: "default",
})
</script>

<template>
  <div
    data-slot="card"
    :data-variant="variant"
    :class="
      cn(
        'text-card-foreground flex flex-col gap-[var(--app-card-gap)] rounded-xl border py-[var(--app-card-padding-y)]',
        variant === 'muted'
          ? 'bg-muted/45 shadow-none dark:bg-muted/30'
          : 'bg-card theme-surface-shadow',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
